import loadStripe from '../LoadStripe/index'
import loadBitcart from '../LoadBitcart/index'
import loadSecurionpay from './loadSecurionpay'

const methods = {
    formStrategy (data) {
        const form = document.createElement('form')

        form.action = data.url
        form.method = data.method
        form.style = 'display: none;'

        let inputs = []
        if (data.fields && data.fields.constructor === Object) {
            inputs = Object.entries(data.fields).map(([name, value]) => {
                const input = document.createElement('input')

                input.type = 'text'
                input.name = name
                input.value = value

                return input
            })
        }

        document.body.appendChild(form)
        inputs.forEach((input) => form.appendChild(input))

        form.submit()
        form.remove()
    },

    stripeCheckoutStrategy (data) {
        loadStripe().then(() => {
            const stripe = window.Stripe(data.public_key)

            stripe.redirectToCheckout({
                sessionId: data.checkout_session_id
            })
        })
    },

    bitcartStrategy (data) {
        loadBitcart({
            loadScriptUrl: data.script_url
        })
        .then(() => {
            window.bitcart.showInvoice(data.invoice_id)
        })
    },

    redirectStrategy (data) {
        window.location.assign(data.redirect_url)
    },

    QRCodeStrategy (data) {
        return data.qr_code_url
    },

    messageStrategy (data) {
        return data
    },
    async securionPayStrategy (data) {
        await loadSecurionpay()

        return new Promise((resolve, reject) => {
            const securionPay = window.SecurionpayCheckout
            securionPay.key = data.public_key

            securionPay.success = function (result) {
                resolve(result)
            }
            securionPay.error = function (errorMessage) {
                reject(errorMessage)
            }

            securionPay.open({
                checkoutRequest: data.signed_checkout_request,
                name: ' ',
                description: 'SecurionPay'
            })
        })
    }
}

function getPaymentStrategy (strategy) {
    const methodName = {
        form: 'formStrategy',
        stripe_checkout: 'stripeCheckoutStrategy',
        redirect: 'redirectStrategy',
        qr_code: 'QRCodeStrategy',
        message: 'messageStrategy',
        securion_pay_charge: 'securionPayStrategy',
        bitcart: 'bitcartStrategy'
    }[strategy]

    if (!methodName) {
        // eslint-disable-next-line
        console.log('NO PAYMENT METHOD STRATEGY FOUND', strategy);
        return undefined
    }

    return methods[methodName]
}

export { loadStripe, methods, getPaymentStrategy }
